var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import Config from '../config/config';
import { getToken } from './token';
var sku = '';
export var ingestData = function ingestData(data, s) {
  try {
    sku = s || sku;
    data = __assign(__assign({}, data), {
      url: window.location.href,
      sku: sku
    });
    var credentials = 'same-origin';
    var headers = new Headers({
      Authorization: "Bearer " + getToken(),
      'Content-Type': 'application/json'
    });
    var requestParams = {
      method: 'POST',
      body: JSON.stringify(data),
      headers: headers,
      credentials: credentials
    };
    fetch(Config.urls.CIMBA_INGEST, requestParams);
  } catch (e) {
    console.log(e);
  }
};